// extracted by mini-css-extract-plugin
export default {"shortcuts":"shortcuts__ww7_tJ"};